import React from 'react'
import PropTypes from 'prop-types'

import styles from './phoneNumber.module.scss'
import { SitePhone } from '../../sitePhone'

const PhoneNumber = ({ className = '', ...rest }) => {
  return (
    <span className={`${styles.phoneNumber} ${className}`} {...rest}>
      <SitePhone />
    </span>
  )
}

PhoneNumber.propTypes = {
  className: PropTypes.string,
}

export { PhoneNumber }
